var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOrangeSliderArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#FF7925"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8295 45.4459L22.4055 33.0343C22.2581 32.8865 22.1539 32.7265 22.0929 32.5541C22.031 32.3817 22 32.197 22 32C22 31.803 22.031 31.6183 22.0929 31.4459C22.1539 31.2735 22.2581 31.1135 22.4055 30.9657L34.8295 18.5172C35.1736 18.1724 35.6037 18 36.1198 18C36.6359 18 37.0783 18.1847 37.447 18.5541C37.8157 18.9235 38 19.3544 38 19.847C38 20.3395 37.8157 20.7704 37.447 21.1398L26.6083 32L37.447 42.8602C37.7911 43.2049 37.9631 43.6295 37.9631 44.1338C37.9631 44.6392 37.7788 45.0765 37.4101 45.4459C37.0415 45.8153 36.6114 46 36.1198 46C35.6283 46 35.1982 45.8153 34.8295 45.4459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrangeSliderArrowLeft);
export default __webpack_public_path__ + "static/media/ic-orangeSliderArrowLeft.171658cfb7fa30c634cda4ae1cac5a96.svg";
export { ForwardRef as ReactComponent };